import React, { useState } from 'react';
import "./About.css";
import CounterCard from './CounterCard';
// import { FaLock, FaTv, FaVolumeUp } from "react-icons/fa";
import bannerImage from "./images/About baner.jpg"; // Adjust path based on your structure

import Catagories from "./images/productcat.png"
import vibrant from "./images/vibrant-0513-3.webp"
import Innovative from "./images/innovative-0513-3.webp"
import Fashionablee from "./images/fashionable-0513-3.webp"
import Premium from "./images/premium-0513-3.webp"

// import EventSection from "../components/";


// Image imports (adjust paths as per your structure)
import imgA1 from "./images/AGM1.jpg";
import imgA2 from "./images/AGM10.jpeg";
import imgA3 from "./images/AGM19.jpg";
import imgA4 from "./images/AGM9.jpg";
import imgA5 from "./images/AGM8.jpeg";
import imgA6 from "./images/AGM2.jpg";
import imgA7 from "./images/AGM3.jpg";
import imgA8 from "./images/AGM18.jpg";

import imgB1 from "./images/EV1.jpg";
import imgB2 from "./images/EV4.jpg";
import imgB3 from "./images/EV17.jpg";
import imgB4 from "./images/EV2.jpg";
import imgB5 from "./images/EV3.jpg";
import imgB6 from "./images/EV6.jpg";
import imgB7 from "./images/EV5.jpg";
import imgB8 from "./images/EV7.jpg";

import imgC1 from "./images/AGM252.jpg";
import imgC2 from "./images/AGM254.jpg";
import imgC3 from "./images/AGM257.jpg";
import imgC4 from "./images/AGM258.jpg";
import imgC5 from "./images/AGM2510.jpg";
import imgC6 from "./images/AGM2517.jpg";
import imgC7 from "./images/AGM2511.jpg";
import imgC8 from "./images/AGM2520.jpg";

import imgD1 from "./images/RR1.jpg";
import imgD2 from "./images/RR10.jpg";
import imgD3 from "./images/RR11.jpg";
import imgD4 from "./images/RR12.jpg";
import imgD5 from "./images/RR13.jpg";
import imgD6 from "./images/RR14.jpg";
import imgD7 from "./images/RR15.jpg";
import imgD8 from "./images/RR16.jpg";
import FeatureSection from './FeatureSection';
import { TestTubeDiagonal } from 'lucide-react';
import Testimonials from './Testimonials';
import Testimonials1 from './Testimonials1';
import Event from './Events';
const eventsData = [
  {
    id: 1,
    title: "Annual General Meeting (2023–2024)",
    cover: imgA1,
    // images: [imgA1, imgA2, imgA3, imgA4, imgA5, imgA6, imgA7, imgA8],
       images: [imgA1, imgA2, imgA3],
  },
  {
    id: 2,
    title: "Red Wolf EV Launching",
    cover: imgB1,
    images: [imgB1, imgB2, imgB3, imgB4, imgB5, imgB6, imgB7, imgB8],
  },
  {
    id: 3,
    title: "Annual General Meeting (2024–2025)",
    cover: imgC2,
    images: [ imgC2, imgC5, imgC6, imgC8],
  },
  {
    id: 4,
    title: "R&R",
    cover: imgD2,
    images: [ imgD2, imgD4, imgD5, imgD6, imgD8],
  },
];

const About = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const brandData = [
    {
      title: "Vibrant",
      img: vibrant,
      heading: "VIBRANT",
      desc: "To spark curiosity, lead with energy, and bring boldness to every innovation we create.",
    },
    {
      title: "Innovative",
      img:Innovative,
      heading: "INNOVATIVE",
      desc: "To challenge convention and craft intelligent, future-ready solutions that redefine everyday experiences.",
    },
    {
      title: "Fashionable",
      img: Fashionablee,
      heading: "FASHIONABLE",
      desc: "To fuse modern design with smart tech — delivering style, sophistication, and performance in every product.",
    },
    {
      title: "Premium",
      img: Premium,
      heading: "PREMIUM",
      desc: "To uphold superior quality, thoughtful design, and a seamless experience across everything we build.",
    },
  ];



  return (
    <div className="about-container">
      <div className="banner-image">
        <img src={bannerImage} alt="About Banner" className="banner-img" />

      </div>
     <section className="stats-section text-center">
          <div className="container">
            <div className="row justify-content-center g-4">

              <div className="col-md-4">
                <CounterCard target={65} label="Super Distributors" />
              </div>

              <div className="col-md-4">
                <CounterCard target={390} label="Distributors" />
              </div>

              <div className="col-md-4">
                <CounterCard target={23400} label="Retailers" />
              </div>

            </div>
          </div>
        </section>

      {/* <section className="section">
        <h2 className="section-title">Our Journey of Innovation</h2>
        <div className="card-grid">
          <div className="card animate-fade-in">
            <h3>Early Innovation</h3>
            <p>
              We began by addressing a critical gap in mobile EMI management with
              the launch of TCOPS Finance Locker, a powerful platform designed to
              protect financial assets through secure, scalable mobile control
              solutions.
            </p>
          </div>
          <div className="card animate-fade-in">
            <h3>Expansion into Smart Entertainment</h3>
            <p>
              We diversified into Redwolf LED TVs and Redwolf Speakers, bringing
              premium technology to Indian homes at competitive value.
            </p>
          </div>
          <div className="card animate-fade-in">
            <h3>Trust Across Verticals</h3>
            <p>
              With over 500,000+ users, Redwolf Info Tech has earned a reputation
              for excellence in security, visual innovation, and sound performance.
            </p>
          </div>
        </div>
      </section> */}
      <section className="rw-mission-vision">
        <div className="rw-split-container">
          {/* Vision Section */}
          <div className="rw-box rw-vision">
            <h2 className="rw-heading">🌟 Vision Statement</h2>
            <p>
              To become India’s most trusted innovation-driven brand, delivering smart lifestyle solutions that seamlessly
unite technology, sustainability, and everyday convenience. We envision a future where every Indian home and journey is empowered by intelligent Red Wolf solutions—designed to simplify life, elevate experiences, and shape a smarter tomorrow
            </p>
            {/* <p>
              We envision a future where every Indian home and journey is empowered by intelligent Red Wolf products —
              designed to simplify life, amplify experiences, and shape a smarter tomorrow.
            </p> */}
            <h4 className="rw-subheading">Our Vision Focuses On:</h4>
            <ul>
              <li>🚗 Sustainable Mobility through intelligently engineered, future-ready electric vehicles</li>
              <li>📺 Connected Living enabled by immersive LED televisions and refined audio solutions</li>
              <li>📱 Digital Empowerment via intelligent financial tools such as EMI lockers</li>
              <li>🏠 Smart Home Evolution with intuitive, design-led appliances (coming soon)</li>
              {/* <li>🇮🇳 Making Innovation Accessible for every Indian household</li> */}
            </ul>
          </div>

          {/* Mission Section */}
          <div className="rw-box rw-mission">
            <h2 className="rw-heading">🚀 Mission Statement</h2>
            <p>
              At Red Wolf Info Tech, our mission is to thoughtfully re-imagine how India moves, connects, and manages
everyday life—through innovation that is purposeful, human-centric, and future-ready. We design and deliver solutions where form meets function, seamlessly blending performance, reliability, andthoughtful design across mobility, entertainment, and digital finance—crafted to solve real needs, in real time.
            </p>
            {/* <p>
              We deliver solutions that blend design, performance, and reliability across mobility, entertainment, and finance
              — built to serve real needs in real time.
            </p> */}
            <h4 className="rw-subheading">Our Mission Drives Us To:</h4>
            <ul>
              <li>⚡ Build sustainable electric mobility solutions engineered for the roads of tomorrow</li>
              <li>🔊 Deliver immersive audio-visual experiences that redefine modern home entertainment</li>
              <li>📊 Create intelligent financial platforms that simplify and empower digital decision-making</li>
              <li>🧠 Introduce future-ready smart appliances designed for everyday comfort and ease</li>
              <li>🛠️ Lead with trust, technology, and a customer-first mindset in everything we build</li>
            </ul>
          </div>
        </div>
      </section>



       <FeatureSection />
      

       <section id="journey">
          <div class="timeline">
            <h1 class="section-title">
              <span class="ev">Our</span> <span class="red">Journey</span>
            </h1>
            {/* <!--first--> */}
            <div class="timeline__event  animated fadeInUp delay-3s timeline__event--type1">
              <div class="timeline__event__icon ">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                July 2019
              </div>
              <div class="timeline__event__content ">
                <div class="timeline__event__title">
                  Stage 1
                </div>
                <div class="timeline__event__description">
                  <p>It all began with an idea. Finance Locker was developed by Rohit Jain (Founder & Chairman), giving
shape to a platform built on trust and security.</p>
                </div>
              </div>
            </div>

            {/* <!--second--> */}

            <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2">
              <div class="timeline__event__icon">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                Oct 2019
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 2
                </div>
                <div class="timeline__event__description">
                  {/* <p>Pankaj Chaturvedi have joined us as a (Co- Founder & Director)</p> */}
                    <p>With strategic leadership from Pankaj Chaturvedi (Co-Founder & Director), the company took formal
shape—turning innovation into a scalable vision.</p>
                </div>
              </div>
            </div>

            {/* <!--third--> */}

            <div class="timeline__event animated fadeInUp delay-1s timeline__event--type3">
              <div class="timeline__event__icon">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                Nov 2019
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 3
                </div>
                <div class="timeline__event__description">
                  <p>The vision reached the nation as Finance Locker was introduced across all states of India, empowering users everywhere.</p>
                </div>

              </div>
            </div>

            {/* <!--forth--> */}

            <div class="timeline__event animated fadeInUp timeline__event--type1">
              <div class="timeline__event__icon">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                Dec 2022
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 4
                </div>
                <div class="timeline__event__description">
                  <p>To amplify its impact, a dedicated sales team was formed — fueling growth and expanding reach.</p>
                </div>
              </div>
            </div>

            {/* <!--first--> */}
            <div class="timeline__event  animated fadeInUp delay-3s timeline__event--type1">
              <div class="timeline__event__icon ">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                October 2023
              </div>
              <div class="timeline__event__content ">
                <div class="timeline__event__title">
                  Stage 5
                </div>
                <div class="timeline__event__description">
                  <p> The journey gains identity as Red Wolf Info Tech Pvt. Ltd. is formally recognized.</p>
                </div>
              </div>
            </div>

            {/* <!--second--> */}

            <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2">
              <div class="timeline__event__icon">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                November 2023
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 6
                </div>
                <div class="timeline__event__description">
                  <p>Innovation takes center stage with the formation of a dedicated IT team.</p>
                </div>
              </div>
            </div>

            {/* <!--third--> */}

            <div class="timeline__event animated fadeInUp delay-1s timeline__event--type3">
              <div class="timeline__event__icon">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                December 2023
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 7
                </div>
                <div class="timeline__event__description">
                  <p>Red Wolf Finance Locker rises as a trusted name and recognized as India’s No.1 Finance Locker
Company in secure financial management.</p>
                </div>

              </div>
            </div>

            {/* <!--forth--> */}

            <div class="timeline__event animated fadeInUp timeline__event--type1">
              <div class="timeline__event__icon">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                February 2024
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 8
                </div>
                <div class="timeline__event__description">
                  <p>A proud milestone—celebrating 4.5 years of growth with 65+ Super Distributors, 390+ Distributors and 23,400+ Retailers PAN India at our Annual General Meeting.</p>
                </div>
              </div>
            </div>

            {/* <!--first--> */}
            <div class="timeline__event  animated fadeInUp delay-3s timeline__event--type1">
              <div class="timeline__event__icon ">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                March 2024
              </div>
              <div class="timeline__event__content ">
                <div class="timeline__event__title">
                  Stage 9
                </div>
                <div class="timeline__event__description">
                  <p>With ambition moving beyond boundaries, Red Wolf EV is launched—redefining the future of electric
mobility and AI-driven innovation.</p>
                </div>
              </div>
            </div>

            {/* add 10th point */}

            <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2">
              <div class="timeline__event__icon">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                March 2025
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 10
                </div>
                <div class="timeline__event__description">
                  <p>The journey expands into everyday living as Red Wolf steps into the home appliances segment,
introducing Smart TVs and Bluetooth speakers.</p>
                </div>
              </div>
            </div>
             <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2">
              <div class="timeline__event__icon">
                {/* <!-- <i class="lni-sport"></i>--> */}

              </div>
              <div class="timeline__event__date">
                January 2026
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 11
                </div>
                <div class="timeline__event__description">
                  <p>A defining leap forward—Red Wolf enters the mobile accessories space with the acquisition of
NationX, accelerating strategic growth and strengthening industry presence.</p>
                </div>
              </div>
            </div>




          </div>
        </section>
        <Testimonials1></Testimonials1>
        <Testimonials></Testimonials>






     

      {/* <section>
        <img src={Catagories} alt="catagories" style={{ width: '100%' }} />
      </section> */}

      <section className="section white-bg">
        <h2 className="section-title">Why Red Wolf?</h2>
        <ul className="benefits-list">
          <li>Purpose-Driven Innovation</li>
          <li>Trust at the Core</li>
          <li>Designed for the Future</li>
        </ul>
        <p className="closing-text animate-slide-up">
         At Red Wolf Info Tech, we build with purpose. Driven by innovation and grounded in trust,
          we create future-ready experiences that feel simple, powerful, and reliable. Every move we make
           is focused on progress—designed to connect people with what truly matters.
        </p>
      </section>

      {/* ATTRIBUTES */}

      {/* <div className="brand-attributes-container">
        <h2 className="brand-title">Red Wolf Attributes</h2>
        <div className="brand-cards">
          {brandData.map((item, index) => (
            <div className="brand-card" key={index}>
              <div className="image-container">
                <img src={item.img} alt={item.title} />
                <div className="overlay-text">{item.heading}</div>
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div> */}


      <div className="event-section">
        <h2 className="section-title">Our Events</h2>

        <div className="card-container">
          {eventsData.map((event) => (
            <div
              key={event.id}
              className="event-card"
              onClick={() => setSelectedEvent(event)}
            >
              <img src={event.cover} alt="event-thumbnail" className="card-img" />
              <h3>{event.title}</h3>
            </div>
          ))}
        </div>

        {selectedEvent && (
          <div className="modal-overlay" onClick={() => setSelectedEvent(null)}>
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()} // Prevent modal close on inner click
            >
              <button className="close-btn" onClick={() => setSelectedEvent(null)}>
                &times;
              </button>
              <h3>{selectedEvent.title} Gallery</h3>
              <div className="image-grid">
                {selectedEvent.images.map((img, idx) => (
                  <img key={idx} src={img} alt={`event-img-${idx}`} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

{/* <Event></Event> */}
  
    </div>
  );
};

export default About;
